import { prefixObjectValues } from '../utils';

const npiLoading = {
  title: 'title',
  loadingSpinner: 'loadingSpinner',
  nextButton: 'next-button',
  backButton: 'back-button',
  loadingBar: 'loading-bar',
  firstName: 'first-name',
  lastName: 'last-name',
  type: 'provider-type',
  npi: 'npi-number',
  npiLookupFailure: 'npi-lookup-failure',
};

export default prefixObjectValues(npiLoading, 'registration-npi-loading');
